import config from "../utils/apiconfig";
import request from "../utils/request";

const { api } = config;
const { hydropower, hydropowerId, hydropowerMapData,hydropowerDelete } = api;

/**
 * 查询列表
 */
export async function list(params) {
  return request({ url: hydropower, method: "get", data: params });
}

export async function getMapData(params) {
  return request({ url: hydropowerMapData, method: "get", data: params });
}

/**
 * 查询详情
 */
export async function gethyDetail(paramId) {
  return request({
    url: hydropowerId,
    method: "get",
    data: {
      id: paramId,
    },
  });
}

/**
 * 编辑
 */
export async function edit(params) {
  return request({ url: hydropowerId, method: "put", data: params });
}

/**
 * 删除
 */
export async function deleteItem(params) {
  return request({ url: hydropowerDelete, method: "post", data: params });
}

/**
 * 创建
 */
export async function createItem(params) {
  return request({ url: hydropower, method: "post", data: params });
}
